export default __webpack_public_path__ + "static/media/tr.5ea59a5e.jpg";